// removed by extract-text-webpack-plugin
module.exports = {"intro":"src-pages----lists-module---intro---223N2","listOuter":"src-pages----lists-module---listOuter---3h3Ru","list":"src-pages----lists-module---list---hxieq"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/lists.module.css
// module id = 657
// module chunks = 84419135593297